import React, { useState } from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './OnlineOrderingNotificationModal.module.scss';
import { useAppContext } from '../../../../../Services/AppContext';
import NetteApiClient from '../../../../../Services/NetteApiClient';
import LinkButton from '../../../../../Components/Button/LinkButton';
import Checkbox from '../../../../../Components/Base/Checkbox/Checkbox';
import LocalStorage from '../../../../../Services/LocalStorage';
import { doNotShowHintAgain } from '../../../Services/manager.service';

interface Props {
	isOpened: boolean;
	onClose: () => void;
}

const OnlineOrderingNotificationModal: React.FC<Props> = ({
	isOpened,
	onClose,
}) => {
	const { redirectToOnlineOrdering } = useAppContext();
	const [doNotShowAgain, setDoNotShowAgain] = useState(false);

	const handleDoNotShowAgain = () => {
		if (doNotShowAgain) {
			doNotShowHintAgain('doNoShowOnlineOrderingNotificationModal');
		}
	};

	const handleSetupOnlineOrderingNow = () => {
		handleDoNotShowAgain();
		onClose();
		if (redirectToOnlineOrdering) {
			NetteApiClient.get(redirectToOnlineOrdering);
		}
	};

	const handleStayOnThisPage = () => {
		handleDoNotShowAgain();
		onClose();
	};

	return (
		<Modal opened={isOpened} onClose={onClose} size={Size.SM}>
			<Modal.Header
				title='component.onlineOrderingNotificationModal.title'
				firstUpper
			/>
			<Modal.Content contentScroll={true}>
				<div className={styles.wrapper}>
					<Text
						tx='component.onlineOrderingNotificationModal.text1'
						className={styles.textBold}
					/>
					<Text
						tx='component.onlineOrderingNotificationModal.text2'
						className='text-center'
					/>
					<Checkbox
						value={doNotShowAgain}
						onChange={() => setDoNotShowAgain(!doNotShowAgain)}
						tx='component.onlineOrderingNotificationModal.checkbox'
					/>
					<div className={styles.controls}>
						<LinkButton
							theme={Theme.BLUE}
							title='component.onlineOrderingNotificationModal.button1'
							onClick={handleStayOnThisPage}
						/>
						<Button
							theme={Theme.GREEN}
							title='component.onlineOrderingNotificationModal.button2'
							onClick={handleSetupOnlineOrderingNow}
						/>
					</div>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default OnlineOrderingNotificationModal;
